export const authenticatorRTTI = Symbol.for("Authenticator");
export const authenticatorDataContainerRTTI = Symbol.for("AuthenticatorDataContainer");
export const authenticatorFactoryRTTI = Symbol.for("AuthenticatorFactory");
export const twilioIdpUrlRTTI = Symbol.for("TwilioIdpUrl");
export const twilioIdpUrlMockOptionsRTTI = Symbol.for("twilioIdpUrlMockOptions");
export const authenticatorMockOptionsRTTI = Symbol.for("authenticatorMockOptions");
